import React, { Component } from 'react';
import style from './index.module.css';

class Chapter3 extends Component<any> {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const { status, favoriteTimes, favoriteName } = this.props.data;
    // if (status !== 1) return;

    return (
      <div
        className={style.pageBox}
        style={{
          height: document.documentElement.clientHeight,
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between'
        }}
      >
        {status === 1 && (
          <div className={style.itemBox}>
            {/* <div className={style.xpIconBox} /> */}
            <p className={style.ordinaryText}>
              <span className={style.blueBigText}>{favoriteName}</span>
              是你2021年最喜欢去的小鹏超充站
              <br />
              <span
                className={style.blueNormalText}
                style={{ fontWeight: 500 }}
              >
                你一共在此充电
              </span>
              <span className={style.blueNormalText}>{favoriteTimes}次</span>
              <br />
              <br />
              <p className={style.grayNormalText}>
                放心前行，你的每次出发都有我们为你喝彩
              </p>
            </p>
          </div>
        )}
        <div className={style.chapter3Icon} />
      </div>
    );
  }
}

export default Chapter3;
